import AxiosConfiguration from '@/classes/AxiosConfiguration';
import { DocumentToStoreUploadModel, DocumentToStoreUploadResultModel } from '@/types/models/documentsToStore';
import { TableSortPropertiesPreference } from '@/types/store/userPreferences/TableSortPropertiesPreference';

const DocumentsToStoreApiUrl = 'DocumentsToStore';
const GetMyDocumentsApiUrl = `${DocumentsToStoreApiUrl}/myDocuments`;
const GetEveryOnesDocumentsApiUrl = `${DocumentsToStoreApiUrl}/everyonesDocuments`;
const GetDocumentsByDocumentTypeApiUrl = `${DocumentsToStoreApiUrl}/documents`;
const UploadDocumentsToStoreUrl = `${DocumentsToStoreApiUrl}/document`;
const GetAllowUploadToDocumentTypeUrl = `${DocumentsToStoreApiUrl}/allowUpload`;

export const DocumentsToStoreService = {
  async getDocumentsToStoreAsync(includeBatchNumber = false) {
    return this.getDocumentsBaseCallAsync(DocumentsToStoreApiUrl, true, includeBatchNumber);
  },
  async getMyDocumentsAsync(includeBatchNumber = false): Promise<any> {
    return this.getDocumentsBaseCallAsync(GetMyDocumentsApiUrl, false, includeBatchNumber);
  },
  async getEveryonesDocumentsAsync(includeBatchNumber = false): Promise<any> {
    return this.getDocumentsBaseCallAsync(GetEveryOnesDocumentsApiUrl, false, includeBatchNumber);
  },
  async getDocumentsByDocumentTypeAsync(documentType: number, includeBatchNumber = false): Promise<any> {
    const url = `${GetDocumentsByDocumentTypeApiUrl}/${documentType}`;
    return this.getDocumentsBaseCallAsync(url, false, includeBatchNumber);
  },
  async getNextDocumentAsync(
    documentTypeId: number,
    documentId: number,
    tableSortPropertiesPreference: TableSortPropertiesPreference
  ): Promise<any> {
    const response = await AxiosConfiguration.axiosWithoutNotification.get(
      // tslint:disable-next-line:max-line-length
      `${GetDocumentsByDocumentTypeApiUrl}/${documentTypeId}/${documentId}/${tableSortPropertiesPreference.sortBy}/${tableSortPropertiesPreference.sortDesc}`
    );
    return response.data;
  },
  async uploadDocumentsToStoreAsync(
    documentToStoreUploadModel: DocumentToStoreUploadModel,
    onUploadProgress: any
  ): Promise<DocumentToStoreUploadResultModel> {
    const formData = new FormData();

    Object.entries(documentToStoreUploadModel).forEach(([key, value]) => {
      formData.append(key, value);
    });

    const response = await AxiosConfiguration.axiosWithoutNotification.post(UploadDocumentsToStoreUrl, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      onUploadProgress
    });
    return response.data;
  },
  async getAllowUploadToDocumentTypeAsync(documentTypeId: number): Promise<boolean> {
    const response = await AxiosConfiguration.axiosWithoutNotification.get(
      `${GetAllowUploadToDocumentTypeUrl}/${documentTypeId}`
    );
    return response.data;
  },
  async getDocumentsBaseCallAsync(url: string, withErrorPage: boolean, includeBatchNumber = false): Promise<any> {
    if (includeBatchNumber) {
      url += '?options.includeBatchNumber=true';
    }
    const response = withErrorPage
      ? await AxiosConfiguration.axiosWithErrorPage.get(url)
      : await AxiosConfiguration.axiosWithoutNotification.get(url);
    return response.data;
  }
};
